import {FC} from "react";

interface TitleProps {
    value: string;
}

export function Title({value}: TitleProps) {
    return <h1>THIS IS MY TITLE {value}</h1>;
}
